// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__iemD1","menuContainer":"menu_menuContainer__2FPlB"};